import React from 'react'
import { Tooltip as AntdTooltip } from 'antd'
import { TooltipPropsWithTitle } from 'antd/lib/tooltip'

export default function Tooltip({ ...props }: TooltipPropsWithTitle) {
  return (
    <AntdTooltip {...props} />
  )
}
